export const trimHashtagSpaces = (hashtags: string) =>
	hashtags
		.split('#')
		.map((str) => str.replace(/\s/g, ''))
		.join(' #')
		.trim();
